import { designToken, quickProperty } from '../component-tokens';
import { largeInputFieldBase, smallInputFieldBase, xLargeInputFieldBase, inputFieldHoverBase, inputFieldFocusBase, inputFieldBase, } from './common';
export const textFieldTokens = {
    name: 'text-field',
    tag: 'chameleon-text-field',
    reactImports: 'Textfield',
    attributes: Object.assign(Object.assign({}, inputFieldBase), { height: quickProperty('2.25rem'), padding: quickProperty('0 0.75rem'), 'box-sizing': quickProperty('border-box'), 'background-color': designToken('ui-01'), outline: quickProperty('0') }),
    sizes: [
        {
            name: 'small',
            attributes: Object.assign({}, smallInputFieldBase),
            children: [
                {
                    name: 'placeholder',
                    attributes: {
                        font: designToken('body-small'),
                    },
                },
            ],
        },
        {
            name: 'large',
            attributes: Object.assign({}, largeInputFieldBase),
        },
        {
            name: 'xlarge',
            attributes: Object.assign({}, xLargeInputFieldBase),
        },
    ],
    states: [
        {
            name: 'hover',
            attributes: Object.assign({}, inputFieldHoverBase),
        },
        {
            name: 'focus',
            attributes: Object.assign({}, inputFieldFocusBase),
        },
    ],
    variants: [
        {
            name: 'success',
            attributes: {
                'border-color': designToken('input-success-border'),
            },
            states: [
                {
                    name: 'focus',
                    attributes: {
                        'border-color': designToken('input-success-border'),
                        'box-shadow': designToken('highlight-success-small'),
                    },
                },
            ],
            children: [
                {
                    name: 'helper-text',
                    attributes: {
                        color: designToken('success-01'),
                    },
                },
            ],
        },
        {
            name: 'danger',
            attributes: {
                'border-color': designToken('input-danger-border'),
            },
            states: [
                {
                    name: 'focus',
                    attributes: {
                        'border-color': designToken('input-danger-border'),
                        'box-shadow': designToken('highlight-error-small'),
                    },
                },
            ],
            children: [
                {
                    name: 'helper-text',
                    attributes: {
                        color: designToken('danger-01'),
                    },
                },
            ],
        },
        {
            name: 'disabled',
            attributes: {
                'border-color': designToken('border'),
                'background-color': designToken('field-04'),
                'box-shadow': quickProperty('none'),
                cursor: quickProperty('default'),
                color: designToken('text-03'),
            },
            children: [
                {
                    name: 'placeholder',
                    attributes: {
                        color: designToken('text-03'),
                    },
                },
            ],
        },
        {
            name: 'readonly',
            attributes: {
                'border-color': designToken('border'),
                'background-color': designToken('surface-color-secondary'),
                'box-shadow': quickProperty('none'),
                color: designToken('text-01'),
            },
            children: [
                {
                    name: 'placeholder',
                    attributes: {
                        color: designToken('text-01'),
                    },
                },
            ],
        },
    ],
    children: [
        {
            name: 'label',
            attributes: {
                color: designToken('text-01'),
                font: designToken('caption-medium-strong'),
                display: quickProperty('block'),
                'margin-bottom': quickProperty('2px'),
            },
        },
        {
            name: 'placeholder',
            attributes: {
                color: designToken('text-02'),
                font: designToken('body-medium'),
                'margin-top': designToken('spacing-01'),
                display: quickProperty('inline-flex'),
                opacity: quickProperty('1'),
            },
        },
        {
            name: 'helper-text',
            attributes: {
                color: designToken('text-02'),
                'margin-top': designToken('spacing-01'),
                font: designToken('caption-medium'),
            },
        },
        {
            name: 'counter',
            attributes: {
                color: designToken('text-02'),
                'margin-top': designToken('spacing-01'),
                font: designToken('caption-medium'),
            },
        },
        {
            name: 'icon',
            attributes: {
                color: designToken('overlay-01'),
                '--goto-icon-size': quickProperty('0.875rem'),
                '--goto-icon-color': designToken('overlay-01'),
            },
        },
        {
            name: 'info-container',
            attributes: {
                display: quickProperty('flex'),
                'justify-content': quickProperty('space-between'),
                'align-items': quickProperty('center'),
                gap: designToken('spacing-02'),
            },
        },
    ],
};
